export default {
  colorPrimary: '#00d8ff',
  colorLightBlue: '#7aa4dd',
  colorDarkBlue: '#00205C',
  colorGray: '#808285',
  colorOrange: '#FF8300',
  fontHeader: 'abril-display',
  fontBody: 'canada-type-gibson',
};
